export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'orders-change-way-modal';

export const REQUIRED_FIELDS = ['way_id'];

export const FORM_FIELDS = ['way_id'];
